const MONTH_NAMES = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December',
]

export const MONTHS = MONTH_NAMES

/**
 * Parses a yyyy-MM-dd string as a *local* calendar date.
 *
 * `new Date('2008-03-12')` is specified to parse as UTC midnight, so west of Greenwich every
 * getFullYear/getMonth/getDate on it reads back the previous day - an off-by-one that turns a
 * birthday into the day before it, and an 18th birthday into a minor.
 */
export function parseIsoDate(iso: string | undefined | null): Date | null {
  if (!iso) return null
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso.trim())
  if (!match) return null
  const [, year, month, day] = match
  const date = new Date(Number(year), Number(month) - 1, Number(day))
  // Rejects the dates the Date constructor silently rolls over, e.g. 2008-02-31 -> 2 March.
  if (date.getMonth() !== Number(month) - 1 || date.getDate() !== Number(day)) return null
  return date
}

/** The inverse of {@link parseIsoDate}: yyyy-MM-dd in local time, never shifted by the offset. */
export function toIsoDate(date: Date): string {
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${date.getFullYear()}-${month}-${day}`
}

export function isoToday(): string {
  return toIsoDate(new Date())
}

/** Shifts today by whole years - for the ends of a date-of-birth range. */
export function isoYearsAgo(years: number): string {
  const date = new Date()
  date.setFullYear(date.getFullYear() - years)
  return toIsoDate(date)
}

/** yyyy-MM-dd -> "12 Mar 2008", or '' if it does not parse. */
export function formatIsoDate(iso: string | undefined | null): string {
  const date = parseIsoDate(iso)
  if (!date) return ''
  return `${date.getDate()} ${MONTH_NAMES[date.getMonth()].slice(0, 3)} ${date.getFullYear()}`
}

export function daysInMonth(year: number, month: number): number {
  return new Date(year, month + 1, 0).getDate()
}
